var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPython(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 116.39 116.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill-rule:evenodd;}.cls-1{fill:url(#Degradado_sin_nombre_8);}.cls-2{fill:url(#Degradado_sin_nombre_7);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_8",
    x1: -285.59,
    y1: 4450.45,
    x2: -285.59,
    y2: 4447.01,
    gradientTransform: "matrix(25, 0, 0, -25, 7183.3, 111261.36)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#327ebd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1565a7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_7",
    x1: -284.42,
    y1: 4449.25,
    x2: -284.42,
    y2: 4445.8,
    gradientTransform: "matrix(25, 0, 0, -25, 7183.3, 111261.36)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9c600"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Front"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.79,0A16.28,16.28,0,0,0,29.26,16V27.1H57.88v3.08H16.54A16.27,16.27,0,0,0,0,46.19v24a16.28,16.28,0,0,0,16.54,16h9.54V72.67a16.28,16.28,0,0,1,16.53-16H73.14a13.78,13.78,0,0,0,14-13.55V16A16.29,16.29,0,0,0,70.6,0ZM42,19.71a5.63,5.63,0,0,0,5.72-5.55,5.73,5.73,0,0,0-11.45,0A5.64,5.64,0,0,0,42,19.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.6,116.39a16.28,16.28,0,0,0,16.53-16V89.3H58.51V86.22H99.86a16.28,16.28,0,0,0,16.53-16v-24a16.27,16.27,0,0,0-16.53-16H90.32V43.72a16.29,16.29,0,0,1-16.54,16H43.25a13.77,13.77,0,0,0-14,13.54v27.1a16.28,16.28,0,0,0,16.53,16Zm3.81-19.7a5.54,5.54,0,1,0,5.73,5.54A5.63,5.63,0,0,0,74.41,96.69Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/PYTHON.8ebb0364b06cdcbd03d0cee57df02012.svg";
export { ForwardRef as ReactComponent };